import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
export const entitiyStatesSlice = createSlice({
    name: 'entity_states',
    initialState,
    reducers: {
        entityStatesCleared: () => {
            return {};
        },
        entityStateUpdated: (state, action) => {
            state[action.payload.entity_id] = { value: action.payload.value, ts: action.payload.ts };
        },
        entityStateDeleted: (state, action) => {
            delete state[action.payload];
        }
    },
});
export const selectEntityStates = (state) => state.entity_states;
export const selectEntityState = (id) => (state) => id == undefined ? undefined : state.entity_states[id];
export const { entityStatesCleared, entityStateUpdated, entityStateDeleted } = entitiyStatesSlice.actions;
export const entityStateAdded = entityStateUpdated;
export default entitiyStatesSlice.reducer;
